import { calloutPropsSchema } from '../component-catalog.js';
export const calloutDefinition = {
    type: 'Callout',
    category: 'content',
    propsSchema: calloutPropsSchema,
    isDataBacked: false,
    needsMeasuredDims: false,
    description: 'Highlighted notice or warning block. Props: text (required), variant? ("info" | "warning" | "success" | "error"), icon?.',
};
//# sourceMappingURL=Callout.js.map